import React, { FC } from 'react';
import LoadingModal from '@components/acca/result/save/modals/loadingModal';
import SaveCompleteModal from '@components/acca/result/save/modals/saveCompleteModal';
import AdditionalTasksModal from '@components/acca/result/save/modals/additionalTasksModal';
import SaveFailModal from '@components/acca/result/save/modals/saveFailModal';
import SaveLoadingModal from '@components/acca/result/save/modals/saveLoadingModal';
import { ContentType } from '@components/acca/result/save';

export type ModalTYpe = 'LOADING' | 'SAVE_LOADING' | 'SAVE_SUCCESS' | 'SAVE_FAIL' | 'ADDITIONAL_TASKS' | null;

interface SaveModalsProps {
  modalState: ModalTYpe;
  setModalState: (modalTYpe: ModalTYpe) => void;
  setContentState: (contentType: ContentType) => void;
}

const SaveModals: FC<SaveModalsProps> = ({ modalState, setModalState, setContentState }) => {
  const isVisible = (modalTYpe: ModalTYpe) => modalTYpe === modalState;

  const onApplyLater = () => {
    setContentState('ACCA_SAVE_SUCCESS');
    setModalState(null);
  };

  return (
    <>
      {/* 로딩 모달 */}
      <LoadingModal visible={isVisible('LOADING')} />

      {/* 저장 로딩 모달 */}
      <SaveLoadingModal visible={isVisible('SAVE_LOADING')} />

      {/* 역검 저장 완료 모달 */}
      <SaveCompleteModal visible={isVisible('SAVE_SUCCESS')} />

      {/* 추가 과제 모달 */}
      <AdditionalTasksModal visible={isVisible('ADDITIONAL_TASKS')} onApplyLater={onApplyLater} />

      {/* 저장 실패 모달 */}
      <SaveFailModal visible={isVisible('SAVE_FAIL')} />
    </>
  );
};

export default SaveModals;
